import { throwError as observableThrowError, Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class HcmConfigService {
    constructor(http) {
        this.http = http;
    }
    getTenantConfig() {
        try {
            return this.http.get(`HCM/tenantsetting`);
        }
        catch (e) {
            return observableThrowError(e);
        }
    }
    getHcmFeaturePermissions() {
        try {
            return this.http.get(`HCM/featurecontrol`);
        }
        catch (e) {
            return observableThrowError(e);
        }
    }
    getHcmSessionInfo() {
        try {
            return this.http.get(`HCM/login`).pipe(map((loginData) => loginData.session));
        }
        catch (e) {
            return Observable.throw(e);
        }
    }
}
HcmConfigService.ɵfac = function HcmConfigService_Factory(t) { return new (t || HcmConfigService)(i0.ɵɵinject(i1.HttpClient)); };
HcmConfigService.ɵprov = i0.ɵɵdefineInjectable({ token: HcmConfigService, factory: HcmConfigService.ɵfac, providedIn: 'root' });
//# sourceMappingURL=hcm-config.service.js.map